import React, { useState, useContext } from "react";
import { GoogleLogin } from "@react-oauth/google";
import api from "../api";
import { AuthContext } from "../context/AuthContext";
const logo = "/logo_vert.png";

const Login = () => {
  const { login } = useContext(AuthContext);
  const [error, setError] = useState(null);

  const handleSuccess = async (credentialResponse) => {
    setError(null);
    try {
      const response = await api.post("/auth/google", {
        credential: credentialResponse.credential,
      });
      const { access_token, refresh_token, is_admin } = response.data;
      login(access_token, is_admin, refresh_token);
    } catch {
      setError("Falha no login. Tente novamente.");
    }
  };

  return (
    <div style={styles.page}>
      {/* Card central */}
      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoWrapper}>
          <img src={logo} alt="Demiplié Doces" style={styles.logo} />
        </div>

        {/* Subtítulo */}
        <p style={styles.subtitle}>Gestão de Estoque</p>

        <div style={styles.divider} />

        {/* Mensagem de erro */}
        {error && (
          <p style={styles.error}>{error}</p>
        )}

        {/* Botão Google */}
        <div style={styles.googleWrapper}>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => setError("Login cancelado ou falhou.")}
            useOneTap
            theme="outline"
            size="large"
            width="280"
            text="signin_with"
            shape="rectangular"
            locale="pt-BR"
          />
        </div>

        <p style={styles.footer}>Acesso restrito · Demiplie</p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(145deg, #f7c5c2 0%, #e8a09c 50%, #d4807c 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "rgba(255, 255, 255, 0.92)",
    backdropFilter: "blur(12px)",
    borderRadius: "24px",
    padding: "48px 40px",
    width: "340px",
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(180, 80, 80, 0.2)",
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "8px",
  },
  logo: {
    width: "260px",
    height: "auto",
    objectFit: "contain",
  },
  subtitle: {
    fontSize: "13px",
    color: "#9e6565",
    letterSpacing: "2px",
    textTransform: "uppercase",
    margin: "0 0 24px 0",
    fontWeight: "500",
  },
  divider: {
    height: "1px",
    background: "linear-gradient(to right, transparent, #e8a09c, transparent)",
    marginBottom: "24px",
  },
  error: {
    color: "#c0392b",
    fontSize: "13px",
    marginBottom: "16px",
    background: "#fdecea",
    borderRadius: "8px",
    padding: "8px 12px",
  },
  googleWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  },
  footer: {
    fontSize: "11px",
    color: "#bda0a0",
    margin: 0,
    letterSpacing: "0.5px",
  },
};

export default Login;
